// 投诉模块
import $http from '../../utils/http';
let refundPath;
const isYyn = window.location.host === process.env.VUE_APP_TIM_C_HOST;
if (isYyn) {
	refundPath = "/backend/api/guest/refund/";
} else if (process.env.NODE_ENV !== "development") {
	refundPath = "tio/refund/api/refund/chat/";
} else {
	refundPath = "/refundApi/refund/chat/";
}

export const checkChat = data => {
	return $http({
		url: refundPath + 'group/check-chat',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const createGroup = data => {
	return $http({
		url: refundPath + 'group/create',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const addMembers = data => {
	return $http({
		url: refundPath + 'group/add-members',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const addMembersWithInfo = data => {
	return $http({
		url: refundPath + 'group/add-members-with-info',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const getSign = params => {
	return $http({
		url: refundPath + 'sign',
		params
	})
};

export const chatAction = data => {
	return $http({
		url: refundPath + 'group/chat-action',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const importAccount = data => {
	return $http({
		url: refundPath + 'account/import',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const preEvaluate = data => {
	return $http({
		url: refundPath + 'pre-evaluate',
		data,
		method: 'POST',
		isPayload: true
	})
};

export const getEvaluate = params => {
	const path = isYyn ? 'chat/evaluate/details' : 'evaluate';
	return $http({
		url: refundPath + path,
		params
	})
};

export const updateEvaluate = data => {
	const path = isYyn ? 'chat/evaluate' : 'evaluate';
	return $http({
		url: refundPath + path,
		data,
		method: 'POST',
		isPayload: true
	})
};

export const refundDetails = params => {
	const path = isYyn ? 'chat/details' : 'details';
	return $http({
		url: refundPath + path,
		params
	})
};
// 投诉
export const report = data => {
	return $http({
		url: '/tio/report/add',
		data,
		method: 'POST',
		isPayload: true
	})
};

// 获取cos票据
export const cosGetFederationToken = params => {
	return $http({
		url: '/tio/file/cos/getFederationToken',
		params
	})
};

export default {
	cosGetFederationToken,
	checkChat,
	createGroup,
	addMembers,
	addMembersWithInfo,
	getSign,
	chatAction,
	importAccount,
	preEvaluate,
	getEvaluate,
	updateEvaluate,
	refundDetails,
	report
}
